import './bootstrap';
import 'livewire-sortable'
import moment from 'moment'
window.moment = moment

import intersect from '@alpinejs/intersect';
import './bootstrap';
// import Bugsnag from '@bugsnag/js';
import '@fortawesome/fontawesome-free/css/all.css';
import.meta.glob([
    '../images/**',
    '../fonts/**',
]);
// Bugsnag.start('02c2e6cd83560482254a5eb604f86008')

const appEnv = import.meta.env.APP_ENV;

// Bugsnag.start({
//     apiKey: '02c2e6cd83560482254a5eb604f86008',
//     enabledReleaseStages: [ 'production', 'beta'],
//     releaseStage: appEnv
// })
